<div class="container">
	<div class="content">
		<div class="list-wrapper nice-scroll visible-scroll colored-scroll-track">
			@for (building of buildings(); track building) {
				<mat-checkbox
					[checked]="selection.isSelected(building)"
					(change)="checkboxChangeHandler($event, building)"
				>
					{{ building.name }}
				</mat-checkbox>
			}
		</div>
	</div>
	<div class="footer">
		<div class="left">
			<div class="description">
				<span class="white-box"> ESC </span>
				<p class="text">{{ 'close' | translate }}</p>
			</div>
		</div>
		<div class="right">
			<button
				mat-ripple
				class="copy-button"
				(click)="copyButtonClicked()"
				[disabled]="!selection.selected.length"
			>
				<span>{{ 'create_copies' | translate }}</span>
			</button>
		</div>
	</div>
</div>
